import { useTranslation } from "react-i18next";

import { DATE_FORMATS_FNS } from "components/DatePicker";
import "components/Notes/NoteRow/components/UserInfo/UserInfo.scss";
import { APPOINTMENT_NOTE_TYPES } from "models";
import { formatDate } from "utils/dateHelperFunctions";

import type { AppointmentNote, User } from "models";

type UserInfoProps = {
  user?: User;
  userId: number;
  updatedBy?: User;
  updatedOn?: string;
  createdOn?: string;
  appointmentNote?: AppointmentNote;
};

export const UserInfo = ({ appointmentNote, updatedBy, user, userId, updatedOn, createdOn }: UserInfoProps) => {
  const { t } = useTranslation();

  const getUserData = () => {
    if (appointmentNote?.public_account_id) {
      return (
        <span>
          {`${t("v8_added_via_api", "Added via Public API")}  ${t("v8_on", "on")}`} {formatDate(createdOn, DATE_FORMATS_FNS.dateMonthYearTime)}
        </span>
      );
    }

    if (appointmentNote?.appointment_note_type_id === APPOINTMENT_NOTE_TYPES.HighVoltageWarning && appointmentNote.created_by_id === 0) {
      return (
        <span>
          {`${t("v8_added_by_claire", "Added by Claire")} ${t("v8_on", "on")}`} {formatDate(createdOn, DATE_FORMATS_FNS.dateMonthYearTime)}
        </span>
      );
    }

    if (appointmentNote?.appointment_note_type_id === APPOINTMENT_NOTE_TYPES.XentryAttachment) {
      const isUpdated = updatedOn && updatedOn !== createdOn;

      return (
        <span>
          {`${isUpdated ? t("v8_updated_by", "Updated by") : t("v8_added_by", "Added by")} Xentry ${t("v8_on", "on")}`}{" "}
          {formatDate(isUpdated ? updatedOn : createdOn, DATE_FORMATS_FNS.dateMonthYearTime)}
        </span>
      );
    }

    if (updatedBy) {
      if (userId)
        return (
          <>
            <span className="user-name">{`${t("v8_updated_by", "Updated by")} ${updatedBy.first_name} ${updatedBy.last_name} ${t("v8_on", "on")}`}</span>
            {updatedOn && <span>{formatDate(updatedOn, DATE_FORMATS_FNS.dateMonthYearTime)}</span>}
          </>
        );

      return <>{updatedOn ? `${t("v8_updated_on", "Updated on")} ${formatDate(updatedOn, DATE_FORMATS_FNS.dateMonthYearTime)}` : ""}</>;
    }

    if (appointmentNote?.is_kiosk_check_in_note)
      return (
        <>
          <span>{`${t("v8_added_by_customer_during_kiosk_check_in_on", "Added by customer during Kiosk Check-in on")} ${formatDate(createdOn, DATE_FORMATS_FNS.dateMonthYearTime)}`}</span>
        </>
      );

    if (userId && user && createdOn) {
      return (
        <>
          <span className="user-name">{`${t("v8_added_by", "Added by")} ${user.first_name} ${user.last_name} ${t("v8_on", "on")}`}</span>
          {createdOn && <span>{formatDate(createdOn, DATE_FORMATS_FNS.dateMonthYearTime)}</span>}
        </>
      );
    }

    return <>{createdOn ? `${t("v8_added_on", "Added on")} ${formatDate(createdOn, DATE_FORMATS_FNS.dateMonthYearTime)}` : ""}</>;
  };

  return (
    <div className="UserInfo">
      <div className="UserInfo__data">{getUserData()}</div>
    </div>
  );
};
